import {
    LightbulbIcon,
    PresentationChartIcon,
    CompassIcon,
    DatabaseIcon,
    BrowsersIcon,
    FileXlsIcon,
    CompassRoseIcon,
    BrainIcon,
} from '@phosphor-icons/react'
import { ROUTES } from '../../router/routes'

const iconStyle = { color: 'white' }

export const navbarItems = [
    {
        icon: <LightbulbIcon size={24} style={iconStyle} />,
        label: 'Insights',
        route: ROUTES.INSIGHTS,
    },
    {
        icon: <PresentationChartIcon size={24} style={iconStyle} />,
        label: 'Canvas',
        route: ROUTES.CANVAS_DASHBOARD,
    },
    {
        icon: <CompassIcon size={24} style={iconStyle} />,
        label: 'Explorer',
        route: ROUTES.EXPLORER,
    },
    {
        icon: <CompassRoseIcon size={24} style={iconStyle} />,
        label: 'Explorer V2',
        route: ROUTES.EXPLORERV2,
        adminOnly: true,
    },
    {
        icon: <DatabaseIcon size={24} style={iconStyle} />,
        label: 'Sources',
        route: ROUTES.SOURCES,
    },
    {
        icon: <BrowsersIcon size={24} style={iconStyle} />,
        label: 'Live Query',
        route: ROUTES.LIVE_QUERY,
        adminOnly: true, // Only visible to A1 accounts
    },
    {
        icon: <FileXlsIcon size={24} style={iconStyle} />,
        label: 'Live Worksheets',
        route: ROUTES.LIVE_WORKSHEETS,
    },
    {
        icon: <BrainIcon size={24} style={iconStyle} />,
        label: 'Domain Intelligence',
        route: ROUTES.DOMAIN_INTELLIGENCE,
        adminOnly: true,
    },
]
